import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAccountRole } from '@/hooks/useAccountRole';
import { notifications } from '@/utils/notifications';

/** Redirects non-admins away from write-only settings routes. */
export function AdminSettingsGuard({ children }: { children: React.ReactNode }) {
  const { canManageAccount, loading } = useAccountRole();
  const navigate = useNavigate();
  const { t } = useTranslation('settings');

  useEffect(() => {
    if (loading || canManageAccount) return;
    notifications.error(t('team.readOnlyNotice'));
    navigate('/settings/profile', { replace: true });
  }, [canManageAccount, loading, navigate, t]);

  if (loading || !canManageAccount) return null;
  return <>{children}</>;
}
